// frontend/src/components/PrepRow.js
import React from 'react';
import './PrepPanel.css';

// value is 'yes' | 'no' | 'unknown'
function getQuestionClass(value) {
  if (value === 'yes') return 'prep-q-card prep-q-yes';
  if (value === 'no') return 'prep-q-card prep-q-no';
  return 'prep-q-card prep-q-unknown';
}

// compute a simple score: % of questions with value === 'yes'
function getRowScore(questions) {
  if (!questions || questions.length === 0) return 0;
  const yesCount = questions.filter(q => q.value === 'yes').length;
  return Math.round((yesCount / questions.length) * 100);
}

// choose right-side indicator color based on score
function getRowIndicatorClass(score) {
  if (score >= 80) return 'prep-row-indicator prep-row-good';
  if (score >= 50) return 'prep-row-indicator prep-row-medium';
  if (score > 0)  return 'prep-row-indicator prep-row-bad';
  return 'prep-row-indicator prep-row-unknown';
}


const PrepRow = ({ row }) => {
  if (!row) return null;

  const { label, name, questions = [] } = row;
  const score = getRowScore(questions);
  const indicatorClass = getRowIndicatorClass(score);

  return (
    <div className="prep-row">
      {/* Left label (P / R / E / P) */}
      <div className="prep-row-label">
        <div className="prep-row-letter">{label}</div>
        {name && <div className="prep-row-name">{name}</div>}
      </div>

      {/* Question cards */}
      <div className="prep-row-questions">
        {questions.map((q) => (
          <div key={q.id} className={getQuestionClass(q.value)}>
            {/* <div className="prep-q-id">Question {q.id}</div> */}
            <div className="prep-q-text">{q.text}</div>
            <div className="prep-q-answer">
              {q.value === 'yes' && 'Yes'}
              {q.value === 'no' && 'No'}
              {q.value === 'unknown' && 'Unknown'}
            </div>
          </div>
        ))}
      </div>

      {/* Right-side indicator (number chip) */}
      <div className={indicatorClass}>
        <div className="prep-row-indicator-score">{score}</div>
      </div>
    </div>
  );
};

export default PrepRow;